"use client";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import Visible from "@/components/visibility/Visible";
import { useUser } from "@/context/user-context";
import { imagePath, makeNameInitials } from "@/lib/userUtils";
import { User } from "lucide-react";
import Link from "next/link";
import { usePathname, useRouter, useSearchParams } from "next/navigation";

export function UserDropdown() {
  const { user } = useUser();
  const { push } = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const handleLogout = async () => {
    // delete cookie
    // await logout();

    // // set user to null
    // setUser(null);
    // Get the current path
    const currentPath = pathname;

    // Get query parameters
    const queryParams = searchParams.toString();
    const qs = queryParams ? `?${queryParams}` : "";

    // Construct login URL
    const loginUrl = `/login?logout=true&redirect=${encodeURIComponent(
      currentPath + qs
    )}`;

    // redirect to login page
    push(loginUrl);
  };

  if (!user)
    return (
      <DropdownMenu modal={false}>
        <DropdownMenuTrigger asChild >
          <User className="cursor-pointer" role="button" aria-label="Open user menu" />
        </DropdownMenuTrigger>
        <DropdownMenuContent className="">
          <DropdownMenuGroup>
            <DropdownMenuItem>
              <Link className="w-full" href="/login">
                Log In
              </Link>
            </DropdownMenuItem>
            <DropdownMenuSeparator />
            <DropdownMenuItem>
              <Link className="w-full" href="/register">
                Sign Up
              </Link>
            </DropdownMenuItem>
          </DropdownMenuGroup>
        </DropdownMenuContent>
      </DropdownMenu>
    );

  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger asChild>
        <Avatar className="cursor-pointer bg-gray-50 dark:bg-gray-900 text-black dark:text-white">
          <AvatarImage src={imagePath(user?.avatar?.url)} className="" />
          <AvatarFallback>
            {makeNameInitials(user?.username || "")}
          </AvatarFallback>
        </Avatar>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="">
        <Visible if={user?.role?.type !== "authenticated"}>
          <DropdownMenuGroup>
            <DropdownMenuItem>
              <Link className="w-full font-bold" href="/dashboard">
                Dashboard
              </Link>
            </DropdownMenuItem>
            <DropdownMenuSeparator />
            <DropdownMenuItem>
              <Link className="w-full" href="/dashboard/articles">
                Articles
              </Link>
            </DropdownMenuItem>
            <DropdownMenuItem>
              <Link className="w-full" href="/dashboard/pages">
                Pages
              </Link>
            </DropdownMenuItem>
            <DropdownMenuSeparator />
            <DropdownMenuItem>
              <Link
                className="w-full"
                href={"/dashboard/profile/" + user?.documentId}
              >
                Profile
              </Link>
            </DropdownMenuItem>
          </DropdownMenuGroup>
        </Visible>
        <Visible if={user?.role?.type === "authenticated"}>
          <DropdownMenuGroup>
            <DropdownMenuItem>
              <Link className="w-full" href="/profile">
                Profile
              </Link>
            </DropdownMenuItem>
          </DropdownMenuGroup>
        </Visible>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={handleLogout} className="cursor-pointer">
          Logout
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
